<template>
	<router-view></router-view>
</template>
<script>


	export default {
		name: 'UserPayinPage',
		components:{

		},
		data() {
			return {

			}
		},
		computed:{

		},
		methods:{

		}

	}
</script>